import { apiGet, apiPatchCamelCase } from '@/network/api/apiAdapter'
import type { CustomerOption } from '@/store/customerContext'

interface ApiResponse<T> {
  code: number
  message: string
  data: T
}

export const getMyCustomersApi = () => apiGet<ApiResponse<CustomerOption[]>>('customer-context/customers')

export const updateCurrentCustomerApi = (data: { name: string; companyName?: string | null }) =>
  apiPatchCamelCase<ApiResponse<CustomerOption>>('customer-context/customers/current', data)
